(() => {
  const gallery = document.querySelector('media-gallery.ns-gallery-limit');
  if (!gallery) return;

  const collage = gallery.querySelector('.product-media-collage');
  if (!collage) return;

  const items = [...collage.querySelectorAll('.product-media-collage__item')];
  const lastVisible = [...items].reverse().find((el) => !el.classList.contains('is-overflow'));
  const rail = gallery.querySelector('.ns-gallery-rail');
  const btnPrev = gallery.querySelector('.ns-gallery-rail__btn[name="prev"]');
  const btnNext = gallery.querySelector('.ns-gallery-rail__btn[name="next"]');
  const section = gallery.closest('.js-product') || gallery;

  const pauseHiddenMedia = (item) => {
    item.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
    item.querySelectorAll('model-viewer').forEach((model) => {
      if (typeof model.pause === 'function') model.pause();
    });
  };

  const setReveal = (mediaId) => {
    const id = String(mediaId);
    const item = items.find((el) => el.dataset.mediaId === id);
    if (!item) return;

    const prevRevealed = items.find((el) => el.classList.contains('is-revealed'));
    items.forEach((el) => el.classList.remove('is-revealed'));
    if (lastVisible) lastVisible.classList.remove('is-displaced');

    if (item.classList.contains('is-overflow')) {
      item.classList.add('is-revealed');
      if (lastVisible) lastVisible.classList.add('is-displaced');
    }

    if (prevRevealed && prevRevealed !== item) {
      pauseHiddenMedia(prevRevealed);
    }
  };

  const scrollRailToThumb = (mediaId) => {
    if (!rail) return;
    const thumb = gallery.querySelector(`.thumbnails .slider__item[data-media-id="${mediaId}"]`);
    if (!thumb) return;

    const railRect = rail.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();
    if (thumbRect.top >= railRect.top && thumbRect.bottom <= railRect.bottom) return;

    rail.scrollTo({
      top: rail.scrollTop + (thumbRect.top - railRect.top),
      behavior: 'smooth'
    });
  };

  const scrollGalleryTop = () => {
    const headerOffset = (window.theme && typeof theme.stickyHeaderHeight === 'function')
      ? theme.stickyHeaderHeight()
      : 0;
    const top = gallery.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  gallery.addEventListener('click', (evt) => {
    const thumbnail = evt.target.closest('.thumbnail');
    if (!thumbnail || !gallery.contains(thumbnail)) return;
    const item = thumbnail.closest('[data-media-id]');
    if (!item || !item.dataset.mediaId) return;
    setReveal(item.dataset.mediaId);
  }, true);

  section.addEventListener('on:variant:change', (evt) => {
    const media = evt.detail && evt.detail.variant && evt.detail.variant.featured_media;
    if (media && media.id) setReveal(media.id);
  }, true);

  gallery.addEventListener('on:media-gallery:change', () => {
    const active = collage.querySelector('.product-media-collage__item.is-active');
    if (!active) return;

    const wasUnrevealedOverflow = active.classList.contains('is-overflow')
      && !active.classList.contains('is-revealed');

    setReveal(active.dataset.mediaId);

    if (wasUnrevealedOverflow) {
      scrollGalleryTop();
    }

    scrollRailToThumb(active.dataset.mediaId);
  });

  const updateArrowState = () => {
    if (!rail || !btnPrev || !btnNext) return;
    const max = Math.max(0, rail.scrollHeight - rail.clientHeight);
    btnPrev.disabled = rail.scrollTop <= 1;
    btnNext.disabled = rail.scrollTop >= max - 1;
  };

  if (btnPrev && rail) {
    btnPrev.addEventListener('click', () => {
      rail.scrollBy({ top: -rail.clientHeight, behavior: 'smooth' });
    });
  }

  if (btnNext && rail) {
    btnNext.addEventListener('click', () => {
      rail.scrollBy({ top: rail.clientHeight, behavior: 'smooth' });
    });
  }

  if (rail) {
    rail.addEventListener('scroll', updateArrowState, { passive: true });
    requestAnimationFrame(updateArrowState);
    window.addEventListener('load', updateArrowState);
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateArrowState).observe(rail);
    }
  }
})();
